import React from "react";

const Unauthorized = () => (
  <div style={{ padding: 40, textAlign: "center" }}>
    <h1>Unauthorized</h1>
    <p>You do not have permission to view this page.</p>
  </div>
);

export default Unauthorized;
